import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { Flex, Text } from 'pcln-design-system'
import { LoaderDots } from '@pcln/fly-ui-components'

const LazyFilters = React.lazy(() =>
  import(/* webpackPrefetch: true */ '../FilterBar/FilterOverlay')
)

const Fallback = () => (
  <Flex flexDirection={'column'} justifyContent={'center'} mt={2}>
    <Text color={'primary.base'} textAlign={'center'}>
      Loading Filters
    </Text>
    <LoaderDots />
  </Flex>
)

const LazyFilterOverlay = ({ onClose, pclnExpt }) => {
  return (
    <Suspense fallback={<Fallback />}>
      <LazyFilters onClose={onClose} pclnExpt={pclnExpt} />
    </Suspense>
  )
}

LazyFilterOverlay.defaultProps = {}

LazyFilterOverlay.propTypes = {
  onClose: PropTypes.func.isRequired,
  pclnExpt: PropTypes.object,
}

export { LazyFilterOverlay as default } // lazy loaded, keeping default
